module.exports = __webpack_public_path__ + "img/music.f72da591.png";